export enum Language {
  English = 'en',
  Spanish = 'es',
  French = 'fr',
  German = 'de',
  Hindi = 'hi',
  Italian = 'it',
  Portuguese = 'pt',
}

export const FlagMap = new Map([
  [Language.English, 'GB'],
  [Language.Spanish, 'ES'],
  [Language.French, 'FR'],
  [Language.German, 'DE'],
  [Language.Hindi, 'IN'],
  [Language.Italian, 'IT'],
  [Language.Portuguese, 'BR'],
]);
